import { SimpleFormSelect, SimpleFormSelectOption } from "src/app/components/form/SimpleFormSelect";
import { Col, Row } from "react-bootstrap";
import { useIntl } from "react-intl";
import { SimpleFormControl } from "../form/SimpleFormControl";

export interface IOrderTextForm {
    writingTypeOptions: { loading: boolean; options: SimpleFormSelectOption[] };
    contentTypeOptions: { loading: boolean; options: SimpleFormSelectOption[] };
    RDOptions: { loading: boolean; options: SimpleFormSelectOption[] };
}
const OrderTextForm = (props: IOrderTextForm) => {
    const { writingTypeOptions, contentTypeOptions, RDOptions } = props;

    const { formatMessage } = useIntl();

    return (
        <Row>
            <Col>
                <SimpleFormSelect
                    name="writingType"
                    label={formatMessage({ id: "common.field.writingType" })}
                    values={writingTypeOptions.options}
                    isLoading={writingTypeOptions.loading}
                />
                <SimpleFormSelect
                    label={formatMessage({ id: "common.field.rd" })}
                    name="rdId"
                    values={RDOptions.options}
                    isLoading={RDOptions.loading}
                />
            </Col>
            <Col>
                <SimpleFormSelect
                    name="contentType"
                    label={formatMessage({ id: "common.field.contentType" })}
                    values={contentTypeOptions.options}
                    isLoading={contentTypeOptions.loading}
                />
                <SimpleFormControl
                    name="wordCount"
                    label={formatMessage({ id: "common.field.wordsCount" })}
                    type="number"
                    min="0"
                    step={1}
                />
            </Col>
        </Row>
    );
};

export default OrderTextForm;
